<template>
  <container>
    <div slot="left_box_content">
      <component :is="curLeftComponent" ></component>
    </div>
    <div slot="right_box_content">
      <component :is="curRightComponent" ></component>
    </div>
    <div slot="bottom_box_content">
      <component :is="curBottomComponent"></component>
    </div>
  </container>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
import investmentElecBasicStoreModule from '@/store/modules/investmentElecBasic'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    Bottom: () => import('./basicComponents/Bottom.vue'),
    Right: () => import('./basicComponents/Right.vue')
  },
  created () {
    if (!this.$store.hasModule('investmentElecBasic')) {
      this.$store.registerModule('investmentElecBasic', investmentElecBasicStoreModule)
    }
  },
  mounted () {
    this.setShowLeftBlock(false)
    this.setShowRightBlock(true)
    this.setShowMap(false)
    this.setBottomHeight('90%')
    this.setLeftComponent('')
    this.setRightComponent('Right')
    this.setBottomComponent('Bottom')
  },
  destroyed () {
    this.$store.unregisterModule('investmentElecBasic')
    this.setShowLeftBlock(false)
    this.setShowMap(false)
    this.setShowRightBlock(false)
    this.setBottomHeight('90%')
    this.setLinkTagArray()
    this.setLinkRouterMaps()
    this.setActivedTagName('')
  }
}
</script>
